import styled from 'styled-components';
import { Ellipse } from 'ui/icons/other/Ellipse';
import { RangeSliderDeprecated } from 'ui/rangeSlider';
import {
  body2,
  body2Bold,
  colors,
  fonts,
  fontWeights,
  smallShadow,
  spacing,
  subtitle1,
  subtitle2,
} from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { MarginLessBody2, XaiDrawerTile } from '../Styled';

export const RadioGroupWrapper = styled.div`
  display: flex;
  min-height: ${spacing.x3};
  gap: ${spacing.double};
`;

export const RadioLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const StyledRadioPercentSign = styled.span`
  ${body2};
  color: ${colors.grey60};
`;

export const StyledSlider = styled(RangeSliderDeprecated)`
  & > div.rc-slider-handle::before {
    border-left: ${spacing.eighth} dashed ${colors.cyan100};
    bottom: 0;
    content: '';
    height: 305px;
    left: 50%;
    opacity: 0.2;
    position: absolute;
    z-index: -1;
  }
`;

export const DistributionGraphContainerTop = styled.div`
  border-radius: ${spacing.half} ${spacing.half} 0 0;
  background: ${colors.white};
  ${smallShadow}
  padding: ${spacing.plusHalf} ${spacing.plusHalf} ${spacing.threeQuarter} ${spacing.plusHalf};
  margin-top: ${spacing.base};
  border-bottom: ${spacing.single} solid ${colors.grey15};
`;
export const DistributionGraphContainerBottom = styled.div`
  border-radius: 0 0 ${spacing.half} ${spacing.half};
  background: ${colors.white};
  ${smallShadow}
  padding: ${spacing.plusHalf};
`;

export const RadioSelectionTitle = styled.div`
  ${body2Bold}
  color: ${colors.textPrimary};
`;

export const CustomDash = styled.span`
  ${body2Bold}
  color: ${colors.textPrimary};
  padding-left: ${spacing.quarter};
  padding-right: ${spacing.quarter};
`;

export const RadioSelectionTextPrimary = styled.span`
  ${body2}
  color: ${colors.textPrimary};
`;

export const RadioSelectionTextSecondary = styled.span`
  ${body2}
  color: ${colors.textSecondary};
  padding-left: ${spacing.quarter};
`;

export const RadioSelectionText = styled(RadioSelectionTextPrimary)`
  padding-left: ${spacing.quarter};
`;
export const RadioCustomRangeText = styled.div`
  padding-left: ${spacing.half};
`;

// 73 and 10 are hardcoded due to the set numbers calculated from the highcharts
export const SliderContainer = styled.div`
  padding: 0 ${pxToRem(10)} ${spacing.half} ${pxToRem(73)};
`;

export const HistogramContainer = styled.div`
  display: flex;
`;

export const HistogramDerivedContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${spacing.double};
`;

export const ContactsSelect = styled.p`
  ${subtitle1}
  margin-bottom: ${spacing.threeQuarter};
`;

export const ConvertAverage = styled.p`
  ${body2}
  display: flex;
  align-items: center;
  margin-bottom: ${spacing.threeQuarter};
`;

export const Predicted = styled.p`
  ${body2}
  margin-bottom: ${spacing.plusHalf};
`;

// Donut Graph slide over
export const DonutChartContainer = styled(XaiDrawerTile)`
  border-radius: ${spacing.half};
  background: ${colors.white};
  border: ${spacing.single} solid ${colors.grey5};
  padding: ${spacing.base};
  margin-top: ${spacing.base};
`;

export const DonutChartHeaderText = styled(MarginLessBody2)`
  flex: none;
  order: 0;
  flex-grow: 0;
  display: flex;
  align-items: center;
  color: ${colors.secondaryText};
  padding-bottom: ${spacing.threeEights};
`;

export const DonutTooltipContent = styled.div`
  padding: ${spacing.quarter} ${spacing.threeQuarter};
  gap: ${pxToRem(10)};
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: ${spacing.quarter};
`;

export const TooltipFeatureText = styled.div`
  ${body2};
  max-width: ${pxToRem(250)};
  color: ${colors.secondaryText};
  word-break: break-word;
  float: left;
`;

export const TooltipPercentageText = styled.div`
  ${body2Bold}
  font-weight: ${fontWeights.bold};
  color: ${colors.black};
  float: right;
`;

export const DisplayTopEventsOrProperties = styled.div`
  & {
    text-align: center;
  }
`;

export const EventOrPropertyListItemContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${spacing.half};
`;

export const XaiDonutColoredDots = styled(Ellipse)`
  height: ${spacing.half};
  width: ${spacing.half};
  min-height: ${spacing.half};
  min-width: ${spacing.half};
`;

export const EventOrPropertyListItem = styled.span`
  font-family: ${fonts.monospaced};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: ${spacing.threeQuarter};
`;

export const EventOrPropertyListItemPercentage = styled.span`
  ${subtitle2};
  color: ${colors.secondaryText};
  white-space: nowrap;
  margin-left: auto;
  max-width: ${pxToRem(26)};
`;

export const XaiExpandTextButton = styled.button`
  ${body2}
  text-decoration: none;
  background: none;
  padding: ${spacing.quarter};
  display: inline-flex;
  border: none;
  & {
    align-items: center;
    :focus {
      outline: none;
    }
  }
`;
